module.exports = __webpack_public_path__ + "28133fcd8e0eb5e8a565ae24d4fa5232.svg";